import { Component, Input, } from '@angular/core';
import { __assign } from 'tslib';
import { env } from 'src/env/development';

@Component({
  selector: 'wac-link',
  templateUrl: 'wacLink.component.html',
  styleUrls: []
})
export class WacLinkComponent {
  @Input() isPebb: boolean | null | undefined;
  @Input() pebbWAC: string | null | undefined;
  @Input() sebbWAC: string | null | undefined;
  @Input() WAC: string | null | undefined;
  @Input() target = '_blank';

  get wac(): string | null | undefined {
    if (this.isPebb === undefined || this.isPebb === null)
      return this.WAC;

    if (!!this.isPebb)
      return this.pebbWAC;

    return this.sebbWAC ?? this.WAC;
  }

  get url(): string {
    const wac = this.wac;
    if (wac)
      return env.wacUrl.replace('{wac}', wac);

    return env.wacUrl;
  }
}
